import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Roles } from '../auth/rbac'
import { useAuth } from '../auth/AuthContext'
import { api } from '../lib/api'
import { useToast } from '../ui/ToastProvider'

function todayIso() {
    const d = new Date()
    const y = d.getFullYear()
    const m = String(d.getMonth() + 1).padStart(2, '0')
    const day = String(d.getDate()).padStart(2, '0')
    return `${y}-${m}-${day}`
}

export default function InsuranceNewsDailyDigestNewPage() {
    const navigate = useNavigate()
    const { hasAnyRole } = useAuth()
    const { show } = useToast()
    const [digestDate, setDigestDate] = useState(todayIso())
    const [title, setTitle] = useState('오늘의 보험 관련 뉴스')
    const [content, setContent] = useState('')
    const [pinned, setPinned] = useState(true)
    const [submitting, setSubmitting] = useState(false)

    const isOperator = hasAnyRole && hasAnyRole([Roles.OPERATOR])

    if (!isOperator) {
        return (
            <div className="p-8 text-center">
                <p className="text-red-600">권한이 없습니다.</p>
            </div>
        )
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (!digestDate || !title.trim() || !content.trim()) {
            show('대상 일자, 제목, 본문을 입력해주세요', 'error')
            return
        }
        setSubmitting(true)
        try {
            const res = await api.post('/insurance-news/daily-digests', {
                digestDate,
                title: title.trim(),
                content: content.trim(),
                pinned,
            })
            const body = (res?.data && res.data.data !== undefined) ? res.data.data : res.data
            const id = body?.id
            if (id) {
                show('다이제스트가 승인 대기로 등록되었습니다', 'success')
                navigate('/work/insurance-news')
            } else {
                show('등록은 완료되었으나 ID를 확인하지 못했습니다', 'warning')
                navigate('/work/insurance-news')
            }
        } catch (err) {
            const message = err?.response?.data?.message || '등록에 실패했습니다'
            show(message, 'error')
        } finally {
            setSubmitting(false)
        }
    }

    return (
        <div className="mx-auto max-w-3xl space-y-6 p-6">
            <div className="flex items-center justify-between">
                <h1 className="text-2xl font-bold">오늘의 보험 뉴스(다이제스트) 등록</h1>
                <button
                    type="button"
                    onClick={() => navigate('/work/insurance-news')}
                    className="text-sm text-slate-600 hover:text-slate-900"
                >
                    목록으로
                </button>
            </div>
            <p className="text-sm text-slate-500">
                링크 모음·요약 본문을 등록합니다. 저장 후 운영자 승인 시 게시됩니다.
            </p>

            <form onSubmit={handleSubmit} className="space-y-6 rounded-lg border border-slate-200 bg-white p-6">
                <div>
                    <label className="block text-sm font-semibold text-slate-700 mb-1">대상 일자</label>
                    <input
                        type="date"
                        value={digestDate}
                        onChange={(e) => setDigestDate(e.target.value)}
                        className="w-full max-w-xs rounded-lg border border-slate-300 px-3 py-2 text-sm"
                    />
                </div>
                <div>
                    <label className="block text-sm font-semibold text-slate-700 mb-1">제목</label>
                    <input
                        type="text"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
                        maxLength={200}
                    />
                </div>
                <div>
                    <label className="block text-sm font-semibold text-slate-700 mb-1">본문 (링크·요약)</label>
                    <textarea
                        value={content}
                        onChange={(e) => setContent(e.target.value)}
                        rows={16}
                        className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm font-mono"
                        placeholder="출처별 링크와 한 줄 요약 등"
                    />
                </div>
                <label className="flex items-center gap-2 text-sm text-slate-700">
                    <input type="checkbox" checked={pinned} onChange={(e) => setPinned(e.target.checked)} />
                    게시 후 목록 상단에 고정(권장)
                </label>
                <div className="flex gap-2">
                    <button
                        type="submit"
                        disabled={submitting}
                        className="rounded-lg bg-brand-sky px-4 py-2 text-sm font-semibold text-white hover:bg-brand-sky/90 disabled:opacity-50"
                    >
                        {submitting ? '등록 중…' : '승인 대기로 등록'}
                    </button>
                </div>
            </form>
        </div>
    )
}
